import { registerPlugin } from "../common/mapstore/registerPlugin";
import { connect } from "react-redux";
import highlightLayerReducer from "./reducer/highlightLayerReducer";
import highlightLayerEpic from "./epic/highlightLayerEpic";
import zoomOutHighlightLayerEpic from "./epic/zoomOutHighlightLayerEpic";

const Highlight = () => {
    return null;
};

export const ConnectedHighlight = connect()(Highlight);

export const HighlightPlugin = {
    name: "HighlightPlugin",
    config: {
        component: ConnectedHighlight,
        reducers: {
            highlight: highlightLayerReducer,
        },
        epics: {
            highlightLayerEpic: highlightLayerEpic,
            zoomOutHighlighLayerEpic: zoomOutHighlightLayerEpic,
        },
    },
};
export const register = () => registerPlugin(HighlightPlugin);
